import React, { useState } from 'react';
import { List } from 'shared/List';
import Modal from 'shared/Modal';
import { Button } from '@cognite/cogs.js';
import { useNavigate } from 'react-router-dom';
import { OnSelectionCallback, OnSetModelOpenCallback } from '../../../types';
import { PhaseDisapproveDescription } from './elements';

export interface UnApprovePhaseModalProps {
  isModalOpen: {
    isOpenModel: boolean;
    phaseId: string;
  };
  supervisorsList: string[];
  setModalOpen: OnSetModelOpenCallback;
  onSelection: OnSelectionCallback;
  projectId: string;
}

export const UnApprovePhaseModal = (props: UnApprovePhaseModalProps) => {
  const [selectedEmail, setSelectedEmail] = useState('');
  const [isOkDisabled, setIsOkDisabled] = useState(true);

  const navigate = useNavigate();

  const onOkClick = () => {
    props.onSelection(selectedEmail, props.isModalOpen.phaseId);
    setSelectedEmail('');
    setIsOkDisabled(true);
  };

  const onListSelectionChange = (email: string) => {
    setSelectedEmail(email);
    setIsOkDisabled(false);
  };

  return (
    <Modal
      visible={props.isModalOpen.isOpenModel}
      setVisible={props.setModalOpen}
      title="Disapproved by Supervisor"
      okText="Disapprove"
      isOkDisabled={isOkDisabled}
      okHandler={onOkClick}
      extraActionButtons={
        <Button
          type="tertiary"
          data-testid="unapprove-add-user-modal"
          onClick={() => navigate(`/project/${props.projectId}`)}
        >
          Add users
        </Button>
      }
    >
      <>
        <div data-testid="disapprove-executors-list">
          <List
            items={props.supervisorsList}
            selectedItem={selectedEmail}
            onSelectionChange={onListSelectionChange}
          />
        </div>

        <PhaseDisapproveDescription>
          After disapproving this phase, you can add new steps. Click the Stop
          Execution button, go back to compile mode, and add a new steps.
        </PhaseDisapproveDescription>
      </>
    </Modal>
  );
};
